import { deepEqual } from 'fast-equals';

export function isEqual(val1, val2) {
    if (typeof val1 === "boolean") {
        return val1 === val2;
    } else if (typeof val1 === "string") {
        return val1 === val2;
    } else if (typeof val1 === "number") {
        return val1 === val2;
    } 

    return deepEqual(val1, val2);
}

export function isDefined(val) {
    return typeof val !== "undefined";
}

export function isUndefined(val) {
    return typeof val === "undefined";
}

export function isNullOrUndefined(val) {
    return isUndefined(val) || val === null;
}

export function isInPartialView(element) {
    const bounding = element.getBoundingClientRect();
    const { top, left, right, bottom } = bounding;
    const { clientWidth,  clientHeight } = document.documentElement || {};
    const { innerWidth, innerHeight } = window;
    const size = {dims: {top, left, right, bottom}, client: {clientWidth,  clientHeight}, window: {innerWidth, innerHeight}};
    const calculatedHeight = Math.floor(bottom - top);
    const calculatedWidth = Math.floor(right - left);
    const partialHeight = (calculatedHeight / 2);
    const partialWidth = (calculatedWidth / 2);
    const winWidth = window.innerWidth || document.documentElement.clientWidth;
    const winHeight = window.innerHeight || document.documentElement.clientHeight;
    const partialRight = winWidth - partialWidth;
    const partialBottom = winHeight - partialHeight;
    const fullRight = winWidth;
    const fullBottom = winHeight;

    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.left <= fullRight &&
        bounding.top <= fullBottom
    ) === true;
}

export function isInViewport(element) {
    return isInPartialView(element);
    // const bounding = element.getBoundingClientRect();

    // if (
    //     bounding.top >= 0 &&
    //     bounding.left >= 0 &&
    //     bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    //     bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    // ) {
    //     return true;
    // } else {
    //     return false;
    // }
}

export function addElementStyles(element, styles) {
    Object.keys(styles).forEach((styleProp) => {
        element.style[styleProp] = styles[styleProp];
    });
}

export async function delay(timeoutMS) {
    return new Promise(res => setTimeout(res, timeoutMS));
}